import React, { useState } from 'react';
import {Link} from 'react-router-dom'

function Submenu() {
  const [isMenuOpen, setisMenuOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [isSubServicesOpen, setIsSubServicesOpen] = useState(false);
  const [isSubBlogOpen, setIsSubBlogOpen] = useState(false);
  const [isSubBlogGridOpen, setIsSubBlogGridOpen] = useState(false);

  const toggleMenu = () => {
    setisMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setisMenuOpen(false);
  };
  const toggleSubmenu = () => {
    setIsSubmenuOpen(!isSubmenuOpen);
  };
  const toggleSubServices = () => {
    setIsSubServicesOpen(!isSubServicesOpen);
  };
  const toggleSubBlog = () => {
    setIsSubBlogOpen(!isSubBlogOpen);
  };
  const toggleSubBlogGrid = () => {
    setIsSubBlogGridOpen(!isSubBlogGridOpen);
  };


  return (
    <div>
     {isMenuOpen && (
        <nav className={`navigation nav-menu ${isMenuOpen ? 'open' : ''}`}>
            <ul className="main-menu">
                <li className="menu-item menu-item-has-children">
                    <Link to="#" onClick={toggleSubmenu} className="active">Home</Link>
                    {isSubmenuOpen && (
                    <ul className="sub-menu">
                        <li className="menu-item">
                            <Link to="/" onClick={closeMenu} >Homepage v1</Link>
                        </li>
                        <li className="menu-item">
                            <Link to="/home-v2" onClick={closeMenu}>Homepage v2</Link>
                        </li>
                    </ul>
                    )}
                </li>
                <li className="menu-item">
                    <Link to="/about" onClick={closeMenu}>About</Link>
                </li>
                <li className="menu-item menu-item-has-children">
                    <Link to="#" onClick={toggleSubServices}>Services</Link>
                    {isSubServicesOpen && (
                    <ul className="sub-menu">
                        <li className="menu-item">
                            <Link to="/services" onClick={closeMenu}>Services</Link>
                        </li>
                        <li className="menu-item">
                            <Link to="/service-details" onClick={closeMenu}>Service Details</Link>
                        </li>
                    </ul>
                    )}
                </li>
                <li className="menu-item">
                    <Link to="/team" onClick={closeMenu}>Team</Link>
                </li>
                <li className="menu-item menu-item-has-children">
                    <Link to="#" onClick={toggleSubBlog}>Blog</Link>
                    {isSubBlogOpen && (
                    <ul className="sub-menu">
                        <li className="menu-item menu-item-has-children">
                            <Link to="#" onClick={toggleSubBlogGrid}>Blog Grid</Link>
                            {isSubBlogGridOpen && (
                            <ul className="sub-menu">
                                <li className="menu-item">
                                    <Link to="/blog-grid" onClick={closeMenu}>Full Width</Link>
                                </li>
                                <li className="menu-item">
                                    <Link to="/blog-grid-left" onClick={closeMenu}>Left Sidebar</Link>
                                </li>
                                <li className="menu-item">
                                    <Link to="/blog-grid-right" onClick={closeMenu}>Right Sidebar</Link>
                                </li>
                            </ul>
                            )}
                        </li>
                        <li className="menu-item">
                            <Link to="/blog-details" onClick={closeMenu}>Blog Details</Link>
                        </li>
                    </ul>
                    )}
                </li>
                <li className="menu-item">
                    <Link to="/contact" onClick={closeMenu}>Contact</Link>
                </li>
            </ul>
            <div className="header_action">
                <Link to="#" className="header_btn thm-btn btn-rounded btn-small"><span className="button_title">Log In</span></Link>
            </div>
        </nav>
        )}
        <div className="hamburger">
        <button className={`hamburger_btn ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
            
                <span></span>
                <span></span>
                <span></span>
           
        </button>
        </div>
    </div>
  )
}

export default Submenu